// EventHeaderIcon.tsx
import React from 'react'
import { statusIconMapping } from './IconMapping'
import {
  AppointmentStatus,
  FormStatus,
  // InsuranceStatus,
  OtherStatus,
  PatientStatus,
  PaymentStatus,
} from '@dataTypes/appointment.type'

// types.ts
export type StatusData = {
  appointment_status: AppointmentStatus
  // insurance_status: InsuranceStatus
  patient_status: PatientStatus
  form_status: FormStatus
  payment_status: PaymentStatus
  other_status: OtherStatus
}

type EventHeaderIconProps = {
  statusData: StatusData
}

export const EventHeaderIcon: React.FC<EventHeaderIconProps> = ({
  statusData,
}) => {
  return (
    <div className="">
      <span className="header-icons-container">
        {Object.keys(statusIconMapping).map((key) => {
          // Type assertion to ensure TypeScript knows the key exists in statusData
          const statusKey = key as keyof StatusData
          const statusValue = statusData[statusKey]
          const IconComponent = statusIconMapping[key](statusValue)
          return IconComponent ? (
            <span key={key} className="icon-wrapper">
              {IconComponent}
            </span>
          ) : null
        })}
      </span>
    </div>
  )
}
